// extracted by mini-css-extract-plugin
export default {"SectionAccordionWrapper":"SectionAccordionWrapper---yRf_o","SectionAccordionWrapper--dragging":"SectionAccordionWrapper--dragging---P4Hma","dragBtn":"dragBtn---XsHG5"};